var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { differenceInMilliseconds } from 'date-fns';
export default class Util {
    /**
     * Executes a passed method and only returns after a given min time.
     *
     * Useful for delaying loaders to prevent quick flashing of html changes.
     *
     * @param method
     * @param minTime
     */
    static execMinTime(method, minTime) {
        return __awaiter(this, void 0, void 0, function* () {
            const startTime = new Date();
            yield method();
            const endTime = new Date();
            const timeTaken = differenceInMilliseconds(endTime, startTime);
            if (timeTaken < minTime) {
                yield Util.sleep(minTime - timeTaken);
            }
        });
    }
    /**
     * Returns whether a value is null or undefined.
     *
     * @param value
     */
    static isNullOrUndefined(value) {
        return value === null || typeof value === 'undefined';
    }
    /**
     * Emulates a sleep in JS using Promises.
     *
     * @param ms
     */
    static sleep(ms) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise(resolve => setTimeout(resolve, ms));
        });
    }
}
//# sourceMappingURL=util.js.map